import React from 'react';
import {SurveyPagePropTypes, useAnswers, NeuroMessage} from '@ignitesales/neuro-application';
import { DonutChart } from '@ignitesales/neuro-application/src/neuro-ui';
import {useRouteMatch} from 'react-router-dom';

const SurveyPage = ({ className, componentClass, renderQuestionGroups }) => {
  const { answers = {} } = useAnswers();
  const matchSurvey = useRouteMatch('/guide/spa/:uuid/checking/balance-page');
  const data =   [
    answers?.averageMonthlyCheckingBalance,
    answers?.averageMonthlySavingsBalance,
    answers?.averageMonthlyCDBalance,
    answers?.averageMonthlyRetirementBalance,
    answers?.investmentAmountToDate_checking,
  ].filter(val => val?.value > 0);
  const colors = {
    averageMonthlyCheckingBalance: '#006747',
    averageMonthlySavingsBalance: '#00b5e2',
    averageMonthlyCDBalance: '#FFD006',
    averageMonthlyRetirementBalance: '#156092',
    investmentAmountToDate_checking: '#78BE20',
  };

  const legendProps = {
    align: 'center',
    verticalAlign: 'bottom',
    layout: 'horizontal'
  }

  return (
    <div className={className}>
      <div className={`questionGroups ${componentClass}__questionGroups`}>

        { renderQuestionGroups() }

        
          {matchSurvey && data.length > 0 ?
            <div className="questionGroup chartContainer">
              <DonutChart
                header={'combinedAccountBalance'}
                data={data}
                colors={colors}
                centerLabel={`$${data.reduce((a, b) => a + b?.value, 0).toLocaleString() || '0'}`}
                legendProps={legendProps}
              
            /></div> : matchSurvey &&
            <div className="questionGroup chartContainer">
              <div className="placeholder">
                <div className="placeholder--graph">
                  <NeuroMessage id="combinedAccountBalance.info" tagName='p' />
                </div>
              </div>
            </div>
          }

      </div>
    </div>
  );
};

SurveyPage.propTypes = SurveyPagePropTypes;

export default SurveyPage;
